import { Input, Table } from '@mantine/core';
import { useDebouncedState } from '@mantine/hooks';
import { IconSearch } from '@tabler/icons-react';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { KeyedRow } from '../../components/KeyedRow';
import { PageHeader } from '../../components/PageHeader';
import { Title } from '../../components/Title';
import { usePagination } from '../../hooks/usePagination';
import { useUrlParams } from '../../hooks/useUrlParams';
import { defaultIconStyle } from '../../theme/styling/iconStyling';
import { query } from '../../util/api/query';
import BankingTotalsRow from './components/BankingTotalsRow';
import type { BankingTotalDto } from './types/BankingTotalDto';

export function BankingTotals() {
	const { organisation } = useParams();
	const pagination = usePagination();

	const [search, setSearch] = useDebouncedState('', 200);

	const searchParams = useUrlParams({ search });

	const paginationParams = useUrlParams({
		search,
		number: pagination.value.pageNumber,
		size: pagination.value.pageSize,
	});

	const bankingQuery = query<BankingTotalDto[]>(
		`${organisation}/banking-totals/all?${paginationParams}`,
	);

	const bankingCountQuery = query<number>(
		`${organisation}/banking-totals/count?${searchParams}`,
	);

	return (
		<>
			<PageHeader title={'Banking Totals'} hideFiltering>
				<Input
					defaultValue={search}
					onChange={(event) => setSearch(event.currentTarget.value)}
					variant={'borderless-filled'}
					placeholder={'Search branch name...'}
					leftSection={<IconSearch {...defaultIconStyle} />}
					w={'20vw'}
				/>
			</PageHeader>
			<DataTable
				pagination={pagination}
				totalItems={bankingCountQuery.data?.value ?? 100}
				isRowsLoading={bankingQuery.isLoading}
				isPaginationLoading={bankingCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Banked Amount'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Last Banked Date'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Last Banked Time'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Banked By'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{bankingQuery.data?.value.map((bankingData) => (
						<BankingTotalsRow initialBank={bankingData} />
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
